module.exports = __webpack_public_path__ + "static/media/pic6.dbc3caec.jpg";